//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ISTH_DIC_overt',
  data() {
    return {
      defaultJson:{
        "Precondition": "先决条件",
        "Fibrinogen ≤ 1.0 g\/L": "纤维蛋白原 ≤ 1.0 g\/L",
        "Moderate increase": "中度升高",
        "None": "无",
        "Not Applicable": "不适用",
        "Repeat scoring daily": "每天重复评分",
        "Strong increase": "大量升高",
        "(Precondition failed)": "（先决条件不符）",
        "Repeat next 1-2 days": "1 - 2 天后重复",
        "No increase": "无升高",
        "Prothrombin time": "凝血酶原时间",
        "Strong": "大量",
        "Suggestive (not affirmative)": "可能（非确定）",
        "precondition hint": "患者是否存在与显性 DIC 相关的潜在异常？",
        "Compatible with overt DIC": "符合显性 DIC",
        "fibrin marker hint": "例如可溶性纤维蛋白单体或纤维蛋白降解产物",
        "Coagulation Test Results": "凝血功能测试结果",
        "Elevated Fibrin-related marker": "纤维蛋白相关标记物升高",
        "Moderate": "中度",
        "Underlying disorder associated with overt DIC": "与显性 DIC 相关的潜在异常",
        "Platelet count": "血小板计数"
      },
      form:{
        precond:'0',
        count:'',
        marker:'1',
        prothrombintime:'',
        fibrinogen:'0',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'无升高',shortName:'无'},
        {value:"2",name:'中度升高',shortName:'中度'},
        {value:"3",name:'大量升高',shortName:'大量'},
      ],
      descTxt:'',
      descMinTxt:'',
      isShowScore:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // precond?(((count>100)?0:((count>50)?1:2))+marker+((prothrombintime>6)?2:((prothrombintime>3)?1:0))+fibrinogen):-1
        let result = form.precond?(((form.count>100)?0:((form.count>50)?1:2))+form.marker+((form.prothrombintime>6)?2:((form.prothrombintime>3)?1:0))+form.fibrinogen):-1
         if (result>=5) {
          self.isShowScore = true
          self.descTxt = self.defaultJson['Compatible with overt DIC']
        } else if(result>=0) {
          self.isShowScore = true
          self.descTxt = self.defaultJson['Suggestive (not affirmative)']
        }else{
          self.isShowScore = false
          self.descTxt = self.defaultJson['Not Applicable']

        }
        if (result>=50) {
          self.descMinTxt = self.defaultJson['Repeat scoring daily']
        } else if(result>=0) {
          self.descMinTxt = self.defaultJson['Repeat next 1-2 days']
        }else{
          self.descMinTxt = self.defaultJson['(Precondition failed)']            
        }
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/ISTH_DIC_overt.vue